module.exports = __webpack_public_path__ + "static/media/Career-Growth.cb1ebdfe.svg";